export default __webpack_public_path__ + "static/media/dev-two.c52c7d56.jpg";